import React from 'react';
import { TimeMap } from '../../../../../elements-date-time/data/time-data';
import PropTypes from 'prop-types';
import { get, findKey, findLastKey } from 'lodash';

export const convertToTimeIndexFn = (value, useFindKey) => {
  return useFindKey ?
    parseInt(findKey(TimeMap, value), 10) :
    parseInt(findLastKey(TimeMap, value), 10);
};

export const ConvertTimeToIndexHOC = (WrappedComponent) => {
  class HOC extends React.Component {
    render () {
      const { input, ...restOfProps } = this.props;
      const inputValue = get(input, 'value.time');
      const startTimeIndex = get(this.props, 'startTimeIndex.time');

      const newInputValue = {
        ...input,
        value: convertToTimeIndexFn(inputValue, this.props.isStartTime)
      };

      return (
        <WrappedComponent
          {...restOfProps}
          input={newInputValue}
          {...(startTimeIndex && { startTimeIndex: convertToTimeIndexFn(startTimeIndex, true) })}
        />
      );
    }
  }

  HOC.propTypes = {
    input: PropTypes.object,
    isStartTime: PropTypes.bool.isRequired
  };
  return HOC;
};

export const normalizeTimeIndex = (index) => {
  return {
    time: {
      h: get(TimeMap, `[${index}].h`),
      m: get(TimeMap, `[${index}].m`)
    }
  };
};
